<template>
  <div class="electronicUploadError">
    <i18n path="illion.uploadError.message">
      <span slot="tryAgainMessage" class="link">
        <a @click="$emit('tryAgain')" v-text="$t('illion.uploadError.tryAgainMessage')" />
      </span>
      <span slot="manualUploadMessage" class="link">
        <a
          @click="$emit('switchToManualMode')"
          v-text="$t('illion.uploadError.manualUploadMessage')"
        />
      </span>
    </i18n>
  </div>
</template>
<script>
export default {
  name: 'electronic-upload-error',
};
</script>
<style lang="sass" scoped>
.electronicUploadError
  margin-bottom: $glass-spacing-4
  text-align: center
  font-weight: bold
  color: $color-system-neutral-black
  +font-size(13.33)

.link
  text-decoration: underline
  cursor: pointer
</style>
